import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';

export default function Library() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);
    
    const asset_slide_sample = 5;
    const [answerView, setAnswerView] = useState(Array(10).fill(false));
const [searchView, setSearchView] = useState('');
    const [questionSample, setQuestionSample] = useState([
        'Q1. 템플릿 라이브러리 이용 대상은 누구인가요?',
        'Q2. 구독 종료 후에도 템플릿 라이브러리을 계속 활용할 수 있나요?',
        'Q3. 템플릿 라이브러리는 향후에도 지속적으로 추가되나요?',
        'Q4. 템플릿 라이브러리 사용이 제한되는 프로젝트 유형은 무엇인가요?',
        'Q5. 템플릿 라이브러리에서 제공하는 에셋의 종류와 내용을 어디서 확인할 수 있나요?',
    ]);


    const [questionSampleEn, setQuestionSampleEn] = useState([
        'Q1. Who is eligible to use template library?',
        'Q2. Can I continue using the template library after my subscription ends?',
        'Q3. Will new template library continue to be added in the future?',
        'Q4. What types of projects are restricted from using template library?',
        'Q5. Where can I view the types of assets included in the template library?'
    ]);
    const answerSample = [
        [
            <>
                Pro는 Plus의 모든 기능을 포함하며, 추가적으로 블렌드 쉐입 모드, Curve 컴포넌트, Quadify 툴, Edge Constraints 툴, Text to 3D 컴포넌트 등 더 많은 확장 기능을 제공합니다. 또한 구독 기간 중 지속적인 기능 업데이트가 이루어집니다.
            </>,
            <>
                Pro는 구독 모델로 UModeler 웹사이트에서 누구나 제한 없이 구독할 수 있습니다. 반면, Plus는 Unity Asset Store에서 구매 가능하며, 연 매출 20만 달러 미만의 개인 및 기업만 사용할 수 있습니다.
            </>,
            <>
                더 자세한 비교는<span>공식 매뉴얼의 FAQ</span>를 참고해 주세요.
            </>
        ],
        /* [
            <>
                기존 UModeler 혹은 Plus를 사용 중인 경우 Pro, Art Pass, All-In-One 연 구독 시 특별 업그레이드 할인 혜택이 제공됩니다. (쿠폰과 중복 가능)
            </>,
            <>
                업그레이드 할인을 위해서는<span onClick={navigate(routes.Price)}>가격 페이지</span>를 참고해 주세요.
            </>
        ], */
    ];
    const [assetLink1, setAssetLink1] = useState([
        'https://assetstore.unity.com/packages/3d/environments/mono-beige-room-umodeler-x-301789',
        'https://assetstore.unity.com/packages/3d/environments/fantasy/the-blacksmith-shop-195344',
        'https://assetstore.unity.com/packages/3d/environments/historic/the-turtle-ship-188209',
        'https://assetstore.unity.com/packages/3d/environments/1900-bastos-station-227123',
        'https://assetstore.unity.com/packages/3d/environments/sunset-train-umodeler-x-304862'
    ]);
    const [assetLink2, setAssetLink2] = useState([
        'https://assetstore.unity.com/packages/3d/environments/fantasy/the-lost-temple-184661',
        'https://assetstore.unity.com/packages/3d/environments/fantasy/the-witch-s-cauldron-186123',
        'https://assetstore.unity.com/packages/3d/environments/dungeons/the-ancient-dungeon-199523',
        'https://assetstore.unity.com/packages/3d/environments/urban/the-riverwalk-city-238950',
        'https://assetstore.unity.com/packages/3d/environments/historic/sunny-hill-village-umodeler-x-298508'
    ]);
    const [assetLink3, setAssetLink3] = useState([
        'https://assetstore.unity.com/packages/3d/environments/historic/the-basilica-cathedral-207123#asset_quality',
        'https://assetstore.unity.com/packages/3d/environments/landscapes/the-pixel-farm-3d-228202',
        'https://assetstore.unity.com/packages/3d/environments/fantasy/the-island-village-179778',
        'https://assetstore.unity.com/packages/3d/props/interior/isometric-lowpoly-room-umodeler-x-285913',
        'https://assetstore.unity.com/packages/3d/environments/fantasy/the-medieval-town-vermilion-193252'
    ]);
    const [assetLink4, setAssetLink4] = useState([
        'https://assetstore.unity.com/packages/3d/environments/fantasy/the-moonglow-village-210011',
        'https://assetstore.unity.com/packages/3d/environments/sci-fi/the-neon-city-183841',
        'https://assetstore.unity.com/packages/3d/environments/urban/the-pastel-town-182014',
        'https://assetstore.unity.com/packages/3d/environments/warm-dream-room-umodeler-x-303461',
        'https://assetstore.unity.com/packages/3d/props/the-medieval-weapons-210012'
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    const ClickAnswerView = (index) => {
        const newAnswerView = [...answerView];
        newAnswerView[index] = !newAnswerView[index];
        setAnswerView(newAnswerView);
    };
    return (
        <>
            <div className="main_back">
                <div className="main_part main_banner">
                    <div className="video_view main library">
                        <HLSVideo
                            width="100%"
                            height="100%"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster={require("../../assets/thumnails/lb_01_thum.webp")}
                            src={"/m3u8/lb_01.m3u8"}
                        >
                            소개 영상입니다.
                        </HLSVideo>
                        
                        <div className="banner_text_box">
                            <p>
                                {lang === 0 ? '템플릿 라이브러리' : 'Template Library'}
                            </p>
                            <span>
                                {lang === 0 ? '여러분의 작업을 도울 멋진 3D 템플릿들을 만나보세요!' : 'Grab some cool 3D templates to boost your work in no time!'}
                            </span>
                        </div>
                        <div className="dark"></div>
                    </div>
                </div>
                <div className="asset_slide_box">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '다양하고 풍부한 3D 템플릿' : 'Diverse and High-Quality 3D Templates'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? 
                                <>
                                    Pro 구독으로 100만원 상당의 고품질 템플릿 라이브러리를 자유롭게 활용해보세요. 작업물의 완성도를 높이고 속도까지 단축됩니다.
                                </>
                                :
                                <>
                                    Unlock a premium template library worth over $700 USD with your Pro subscription. Elevate your work quality and speed up your creative process.
                                </>
                            }
                        </span>
                    </div>
                    <div className="video_slide_container">
                        <div className="video_slide_track art_pass">
                            {[
                                "cathedeal.jpg",
                                "robot.png",
                                "train.jpg",
                                "farm.jpg",
                                "losttemple.jpg",
                                "sunnyhillvillage.jpg",
                                "island.jpg",
                                "medievaltown.jpg",
                                "dungeon.jpg",
                                "rivercity.jpg",
                                "pasteltown.jpg",
                            ].map((x, i) => (
                                <div className="video_slide_item art_pass" key={i}>
                                    <div className="video_view">
                                        <img src={require("../../assets/artpass/"+ x +"")} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="video_slide_container sub">
                        <div className="video_slide_track sub art_pass">
                            {[
                                "weapon.jpg",
                                "neoncity.jpg",
                                "witchscauldrun.jpg",
                                "moonglowvillage.jpg",
                                "warmdreamroom.jpg",
                                "blacksmith.jpg",
                                "monobeigeroom.jpg",
                                "livingKitchenLounge.jpg",
                                "turtleship.jpg",
                                "sunsettrain.jpg",
                                "isometricroom.jpg"
                            ].map((x, i) => (
                                <div className="video_slide_item art_pass" key={i}>
                                    <div className="video_view">
                                        <img src={require("../../assets/artpass/"+ x +"")} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                </div>
                <div className="asset_slide_box">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '주요특징' : 'Key Features'}
                        </p>
                    </div>
                    
                    <div class="artpassnewsection">
                        <div>
                            <div>
                                <img className="navi" width={30} src={require("../../assets/icon/navi_icon.svg").default} />
                                {lang === 0 ? '무제한 액세스' : 'Unlimited Access'}
                            </div>
                            <div>
                                {lang === 0 ? '템플릿 라이브러리에 포함된 모든 에셋을 제한 없이 사용할 수 있습니다.' : 'Use all assets included in the template library without any limitations.'}
                            </div>
                        </div>
                        <div>
                            <div>
                                <img className="navi" width={30} src={require("../../assets/icon/navi_icon.svg").default} />
                                {lang === 0 ? '고품질 에셋' : 'High-Quality Assets'}
                            </div>
                            <div>
                                {lang === 0 ? '100만 원 상당의 다양한 스타일과 테마의 고퀄리티 에셋을 제공해 3D 프로젝트에 자유롭게 활용할 수 있습니다.' : 'Get $700 worth of high-quality assets in diverse styles and themes for use in any 3D project.'}
                            </div>
                        </div>
                        <div>
                            <div>
                                <img className="navi" width={30} src={require("../../assets/icon/navi_icon.svg").default} />
                                {lang === 0 ? '실시간 편집' : 'Real-Time Editing'}
                            </div>
                            <div>
                                {lang === 0 ? 'UModeler X와의 완벽한 호환으로 에셋을 유니티에서 실시간으로 편집할 수 있습니다.' : 'With full integration of UModeler X, you can edit assets in real-time directly in Unity.'}
                            </div>
                        </div>
                    </div>
                </div>
                

                <div className="main_part padding">
                    <div className="title_box">
                        {lang === 0 ? '자주 묻는 질문' : 'FAQ'}
                    </div><br /><br />

                    <div className="question_box">
                        {questionSample.map((x, i) => (
                            <div
                                key={i}
                                className={`question_list ${answerView[i] ? 'on' : ''}`}
                                onClick={() => {
                                    ClickAnswerView(i)
                                    /* console.log(i); */
                                }}
                            >
                                <b>{lang === 0 ? x : questionSampleEn[i]}</b>

                                {answerView[i] &&
                                    <div className="answer">
                                        <div
                                            className="answer_text_box"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                            }}
                                        >
                                            {i === 0 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    템플릿 라이브러리는 Pro와 Enterprise 플랜의 유료 구독자에게만 제공됩니다. 템플릿은 구독 기간 동안 자유롭게 이용하실 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Template Library are available exclusively to users subscribed to the Pro and Enterprise plans. Access is granted for the full duration of an active subscription.
                                                                </>
                                                            }

                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    단, Pro 무료 체험(Free Trial) 사용자에게는 템플릿이 제공되지 않습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Please note that users on the Pro Free Trial plan are not eligible to use template library.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>                                                    
                                                </>
                                            }

                                            {i === 1 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    구독이 종료된 이후에는 템플릿 라이브러리을 기존에 출시된 프로젝트의 유지보수(예: 버그 수정) 목적으로만 계속 사용할 수 있습니다.                                                                    
                                                                </>
                                                                :
                                                                <>
                                                                    Once your subscription ends, you may continue to use template library only for maintenance purposes (e.g., bug fixes) in existing, released projects.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    단, 새로운 기능 개발, 주요 업데이트 진행, 신규 프로젝트 시작 등은 유효한 구독 상태에서만 가능합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    However, if you plan to develop new features, release major updates, or start new projects, a valid subscription is required.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 2 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    네. UModeler X 템플릿 라이브러리는 정기적으로 고품질 신규 에셋이 추가되며 지속적으로 확장될 예정입니다.                                                                    
                                                                </>
                                                                :
                                                                <>
                                                                    Yes. The UModeler X Template Library is continuously expanding, with new high-quality assets being added on a regular basis.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    보다 다양한 스타일과 테마의 에셋을 통해 창작 및 개발의 폭을 넓혀갈 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Our goal is to provide a growing collection that supports a wide range of creative and development needs.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 3 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    다음과 같은 유형의 프로젝트에서는 템플릿 라이브러리 사용이 제한됩니다
                                                                </>
                                                                :
                                                                <>
                                                                    Template library may not be used in the following types of projects.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    생성형 AI 학습 또는 AI 기반 변형 프로젝트
                                                                </>
                                                                :
                                                                <>
                                                                    Generative AI training or AI-based asset transformation.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    스톡 콘텐츠 플랫폼(스톡 이미지, 2D/3D 에셋 배포 등)
                                                                </>
                                                                :
                                                                <>
                                                                    Stock content platforms (e.g., stock images, 3D/2D asset packs)
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    콘텐츠 제작 시스템, 게임 엔진, 미들웨어 등 개발
                                                                </>
                                                                :
                                                                <>
                                                                    Development of content creation systems, engines, or middleware
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <p>✅</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Roblox, VRChat 등 플랫폼 내 UGC(사용자 생성 콘텐츠) 제작은 허용됩니다. 단, 해당 플랫폼 자체를 개발하는 것은 금지됩니다.
                                                                </>
                                                                :
                                                                <>
                                                                    UGC content creation within platforms like Roblox, or VRChat is permitted. However, developing such platforms yourself is not allowed.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>                                                    
                                                </>
                                            }

                                            {i === 4 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X 템플릿 라이브러리에 포함된 에셋의 종류, 스타일, 카테고리 등 자세한 내용을 알고 싶으시다면, 공식 문서 페이지를 통해 확인하실 수 있습니다.
                                                                    아래 링크에서 최신 템플릿 에셋 정보를 확인해주세요.
                                                                </>
                                                                :
                                                                <>
                                                                    If you would like to explore the types, categories, and styles of assets provided in the UModeler X Template Library, please refer to our official documentation.
                                                                    You can find the most up-to-date information on available templates at the following link.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    🔗
                                                                    <span
                                                                        className="right"
                                                                        onClick={() => {
                                                                            window.open('https://docs.umodeler.com/ko/umodeler-x-template/library/')
                                                                        }}
                                                                    >
                                                                        템플릿 라이브러리 보기
                                                                    </span>
                                                                </>
                                                                :
                                                                <>
                                                                    🔗
                                                                    <span
                                                                        className="right"
                                                                        onClick={() => {
                                                                            window.open('https://docs.umodeler.com/umodeler-x-template/library/')
                                                                        }}
                                                                    >
                                                                         View the Template Library
                                                                    </span>
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    템플릿 라이브러리로 생산성을 높이세요 
                                </>
                                :
                                <>
                                    Speed up with Template Library.
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    window.scrollTo({
                                        top: 0,
                                    })
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '더 알아보기' : 'Learn More'}
                            </button>
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact Us'}
                            </button>
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
